import React from 'react';

import { StyledCheckoutStepList } from './CheckoutStepList.styles';

import {
  CheckoutStepListProps,
  CheckoutStepProps,
} from './CheckoutStepList.types';

const CheckoutStepList = ({
  stepList,
  handleTitleClick = () => {},
  componentClassname = 'checkout-step-list',
  customClassnames = '',
  customStyle = '',
}: CheckoutStepListProps) => {
  if (!stepList.length) return null;

  return (
    <StyledCheckoutStepList
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      {stepList.length && (
        <div className={`${componentClassname}__step-list`}>
          {stepList.map((step: CheckoutStepProps) => (
            <div
              key={step.id}
              className={`${componentClassname}__step ${
                step.isOpen ? `${componentClassname}__step--is-open` : ''
              }${
                step.isValidated
                  ? `${componentClassname}__step--is-validated`
                  : ''
              }`}
            >
              <div
                className={`${componentClassname}__step-title-wrapper`}
                onClick={() => {
                  handleTitleClick(step.id);
                }}
              >
                {step.beforeStepTitleSlot}
                <span className={`${componentClassname}__step-title`}>
                  {step.title}
                </span>
                {step.afterStepTitleSlot}
              </div>
              {step.isOpen && (
                <div className={`${componentClassname}__step-content`}>
                  {step.content}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </StyledCheckoutStepList>
  );
};
CheckoutStepList.displayName = 'CheckoutStepList';

export default CheckoutStepList;
